import {
    Component,
    EventEmitter,
    Output,
    Input
} from '@angular/core';

import { TreeNode } from 'primeng/api';
import { v4 as uuidv4 } from 'uuid';

import { messageSeverityEnum } from '../../../Misc/enums/message-severity.enum';
import { DataBrowserType } from '../../../Dialogs/models/data-select-dialog.model';
import { TreeListTypesEnum } from '../../enums/tree-list-types.enum';


@Component({
    selector: 'agpr-tree-list',
    templateUrl: './tree-list.component.html',
    styleUrls: ['./tree-list.component.scss'],
    standalone: false
})
export class TreeListComponent {
    readonly messageSeverityEnum = messageSeverityEnum;
    readonly treeListTypesEnum = TreeListTypesEnum;

    private _items: TreeNode[] = [];

    @Input()
    set items(value: TreeNode[]) {
        this._items = value || [];
        // ensure keys are set
        this.generateKey(this._items);
    }

    get items(): TreeNode[] {
        return this._items;
    }

    @Input() selection: TreeNode[];
    @Input() selectionMode: string = 'checkbox';
    @Input() filterMode: boolean = false;
    @Input() styleClass: string = null;
    @Input() lockMessage: string = 'Your account does not have access to this';
    @Input() expandedIcon: string = 'fa fa-caret-down';
    @Input() collapsedIcon: string = 'fa fa-caret-right';
    @Input() style: TreeListTypesEnum = TreeListTypesEnum.normal;
    @Input() totalResults: number;
    @Input() hideParentCheckbox: boolean = true;
    @Input() showCountTooltip: boolean = true;

    /* The 'type' of the node to display, required for filtering */
    @Input() templateDataType: DataBrowserType = null;
    @Input() filterString: string[] = [];

    @Input() propagateSelectionUp: boolean = true;
    @Input() propagateSelectionDown: boolean = true;

    @Output() selectionChange: EventEmitter<any> = new EventEmitter();
    @Output() nodeSelect: EventEmitter<any> = new EventEmitter();
    @Output() nodeUnselect: EventEmitter<any> = new EventEmitter();
    @Output() nodeExpand: EventEmitter<any> = new EventEmitter();
    @Output() nodeCollapse: EventEmitter<any> = new EventEmitter();

    constructor() { }

    generateKey(nodes: TreeNode[]): void {
        nodes.forEach((node) => {
            if(!node.key){
                node.key = uuidv4();
            }
            if (node.children && node.children.length > 0) {
                this.generateKey(node.children);
            }
        });
    }
}
